export default "__VITE_ASSET__9eXZZLL9__"